import React from "react";
import type { AvatarLayers } from "../types/leagueDuel";
import { DUELIST_CHARACTER_IMG } from "../data/mockTeams";

// ─── Avatar composé (mêmes calques que le Profil) ─────────────────────────────
// Ordre de z-index : ball(0) → familiar(1) → character(2) → shoes(3) → top(4) → head(5).
// `layers` est optionnel : sans calques, on n'affiche que le personnage de base.

export function LayeredCharacter({
  layers,
  mirror,
  glowColor,
  style,
}: {
  layers?: AvatarLayers;
  mirror?: boolean;
  glowColor?: string;   // lueur rapide (succès) — vert pour nous, rouge pour l'adversaire
  style?: React.CSSProperties;
}) {
  const L = layers ?? {};
  const layerStyle: React.CSSProperties = {
    position: "absolute", inset: 0, width: "100%", height: "100%",
    objectFit: "contain", pointerEvents: "none",
  };
  // Ghost image = imposes the aspect ratio. Width-driven by default (Duel), but
  // height-driven when the caller sizes via style (e.g. height:100% / width:auto).
  const ghostStyle: React.CSSProperties = {
    display: "block",
    width: style?.width ?? "100%",
    height: style?.height ?? "auto",
    visibility: "hidden",
  };
  return (
    <div
      style={{
        position: "relative",
        transform: mirror ? "scaleX(-1)" : undefined,
        filter: glowColor ? `drop-shadow(0 0 10px ${glowColor}) drop-shadow(0 0 18px ${glowColor})` : undefined,
        transition: "filter .18s ease-out",
        ...style,
      }}
    >
      {/* Image fantôme qui impose la hauteur */}
      <img src={DUELIST_CHARACTER_IMG} alt="" style={ghostStyle} />
      {L.ball && <img src={L.ball} alt="" style={{ ...layerStyle, zIndex: 0 }} />}
      {L.familiar && <img src={L.familiar} alt="" style={{ ...layerStyle, zIndex: 1 }} />}
      <img src={DUELIST_CHARACTER_IMG} alt="" style={{ ...layerStyle, zIndex: 2 }} />
      {L.shoes && <img src={L.shoes} alt="" style={{ ...layerStyle, zIndex: 3 }} />}
      {L.top && <img src={L.top} alt="" style={{ ...layerStyle, zIndex: 4 }} />}
      {L.head && <img src={L.head} alt="" style={{ ...layerStyle, zIndex: 5 }} />}
    </div>
  );
}
